// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"dd5e96a2","647":"40b0917f","787":"cf733e01","798":"f894ea42"}[chunkId] + ".chunk.js";
};